import React from 'react'
import {Lang} from 'yougile-lang'
import {PageComponent} from '@components/page/page-component'
import {SimplePageTitle} from '@components/page/simple-page-title'
import {StatsTimeline} from '@components/statistics/stats-timeline/stats-timeline'

export const EventFeedPage = () => {
  const title = <SimplePageTitle title={Lang.msg.actionsByTime} />
  return (
    <PageComponent title={title}>
      <StatsTimeline />
    </PageComponent>
  )
}
